var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2900",
    "data-name": "Trac\\xE9 2900",
    d: "M50,25A25,25,0,1,1,25,0,25,25,0,0,1,50,25",
    transform: "translate(0 -0.001)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2901",
    "data-name": "Trac\\xE9 2901",
    d: "M105.816,123.358a6.76,6.76,0,0,1,11.594-5.882,17.066,17.066,0,0,0,4.007-1.79,7.374,7.374,0,0,1-2.984,3.751,12.706,12.706,0,0,0,3.666-1.023,7.125,7.125,0,0,1-3.154,3.154C120.053,137,103.429,146.375,89.96,138.7c0,0,6.649.341,9.463-2.9,0,0-4.092.341-6.138-4.6a4.112,4.112,0,0,0,3.069-.17s-4.774-.767-5.2-6.479a4.2,4.2,0,0,0,3.24.767s-5.285-3.154-2.3-8.866c0,0,5.627,7.161,13.725,6.905",
    transform: "translate(-80.578 -103.002)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f14cf87011a739555ea4a14c72a2ceb8.svg";
export { ForwardRef as ReactComponent };